import React, { useState, useEffect } from 'react';
import { Container } from 'reactstrap';
import Common_Header from './common/views/header/Common_Header';
import Accessibility from './common/package/accessibility/Accessibility';
import Common_Footer from './common/views/footer/Common_Footer';
import SessionInitialization from './common/storage/SessionInitialization';
import { Outlet, useLocation } from 'react-router-dom';
import icon_building from './images/img-building.png'
import icon_btn2 from './images/btn-2.png'
import toast, { Toaster } from 'react-hot-toast';
import SiteMap from "./common/views/sitemap/SiteMap";
import Menu_Function_List from "./common/views/menu/Menu_Function_List";
import scrollToAnchor from "./common/package/scrollToAnchor";

function Layout(prop) {
    var localhost = useLocation();

    const [data, setData] = useState({
        mode: 'wait',
        display_name: '',
        type: '0',
        active: '0'
    });

    useEffect(function () {
        if (data.mode == 'wait') {
            SessionInitialization.init();
            data.mode = 'ok';
            setData({ ...data });
        }
    }, [data]);

    useEffect(function () {

        scrollToAnchor('Content');

    }, [localhost]);


    /**
     * 收合footer地圖
     * */
    function Collapse() {
        document.getElementById("condensation").onclick = () => {
            const webMap = document.getElementById("webmap");
            var footer = document.querySelector('.footer');
            console.log(webMap.offsetHeight);
            if (webMap.offsetHeight) {

                webMap.style.display = "none";
                webMap.style.height = "0px";
                webMap.style.padding = "0";
            } else {
                webMap.style.height = "auto";
                webMap.style.padding = "5rem 0 2rem";
                webMap.style.display = "block";
            }
        };
    }

    if (data.mode != 'wait') {


        return (
            <>
                <Accessibility lang="tw" />
                <Toaster />
                <Common_Header />

                <div className="content" id="mainContent">
                    <div className="layout_content">
                        <Outlet />



                    </div>
                    <img className="bg-pos-1" src={icon_building} alt="" />

                    <div role="button" onClick={Collapse} aria-label="收合網站地圖">
                        <img id="condensation" className="bg-pos-2 cp desktop" src={icon_btn2} alt="" />
                    </div>
                </div>
                <Common_Footer />
            </>
        );
    }
}
export default Layout;
